module.exports = __webpack_public_path__ + "img/purple.5d2fa185.png";